import getters from './getters'

const state = {
  warning_dialog: false,
  permissions_form: {
    show: false,
    mode: 'create'
  },
  roles_form: {
    show: false
  },
  assignation_form: {
    show: false
  },
  unassign_dialog: {
    show: false
  }
}

const mutations = {
  hide_warning_dialog: (state) => {
    state.warning_dialog = false
  },
  show_warning_dialog: (state) => {
    state.warning_dialog = true
  },
  hide_permissions_form: (state) => {
    state.permissions_form.show = false
  },
  show_permissions_form: (state) => {
    state.permissions_form.show = true
  },
  set_permissions_form_mode: (state, mode) => {
    state.permissions_form.mode = mode
  },
  show_roles_form: (state) => {
    state.roles_form.show = true
  },
  hide_roles_form: (state) => {
    state.roles_form.show = false
  },
  show_assignation_form: (state) => {
    state.assignation_form.show = true
  },
  hide_assignation_form: (state) => {
    state.assignation_form.show = false
  },
  show_unassign_dialog: (state) => {
    state.unassign_dialog.show = true
  },
  hide_unassign_dialog: (state) => {
    state.unassign_dialog.show = false
  }
}

export default {
  state,
  mutations,
  getters
}
